import { HttpUrlEncodingCodec } from "@angular/common/http";
import { ModuleConfig } from "@shared-config/moduleConfig";

export class UrlHelper {
  private static _encoder: HttpUrlEncodingCodec = null;

  static get encoder(): HttpUrlEncodingCodec {
    if (!this._encoder) {
      this._encoder = new HttpUrlEncodingCodec();
    }
    return this._encoder;
  }

  static readonly testPage = "/Home2/";
  static readonly landingPage = "/Landing-Page/";
  static readonly findExpertPage = "/Find/";
  static readonly iFramePaymentForm = "/IFrameAccount/PaymentForm/";
  static readonly iFramePaymentResult = "/IFrameAccount/PaymentResult/";
  static readonly iFrameAuthoriseResult = "/IFrameAccount/AuthoriseResult/";
  static readonly externalScriptLoggedInJs = "/bundles/LoggedInJs.min.js";
  static readonly externalScriptGooglePay = "https://pay.google.com/gp/p/js/pay.js";
  static readonly externalScriptPayPal = "https://www.paypalobjects.com/api/checkout.js";
  static readonly messageReceivedSound = "/Assets/Audio/MessageAlert.mp3";

  static searchPage(searchTerm: string): string {
    return UrlHelper.encoder.encodeValue("/Search/" + searchTerm)
  }

  static expertPageOnlineChatResume(expertNickname: string, config: ModuleConfig): string {
    return UrlHelper.encoder.encodeValue(`${config?.UrlExpertProfilePagePrefix}${expertNickname}/Resume/`);
  }

  static navigateToUrl(url: string): void {
    window.location.href = url ?? "/";
  }

  static isCurrentUrlPath(urlPath: string): boolean {
    let currentUrlPath: string = window?.location?.pathname;
    if (UrlHelper.sanitiseUrlForComparison(currentUrlPath).startsWith(UrlHelper.sanitiseUrlForComparison(urlPath))) {
      return true;
    }
    else {
      return false;
    }
  }

  private static sanitiseUrlForComparison(url: string): string {
    if (url === null) return url;
    let returnUrl: string = url;
    returnUrl = returnUrl.toLowerCase();
    if (returnUrl.endsWith("/")) returnUrl = returnUrl.slice(0, returnUrl.length - 1);
    if (!returnUrl.startsWith("/")) returnUrl = "/" + returnUrl;
    return returnUrl;
  }
}
